module.exports = __webpack_public_path__ + "img/basic.a3c9265a.png";